/* ── SITE MAP: one hierarchy for every navigation surface ──
   Main nav → section → page. The header shows the five top-level entries;
   a section's own pages appear as a section nav under the page title; the
   mobile menu and footer group links the same way. GLOSS is the one line
   a where-next plate shows about a destination. */

export const SECTIONS = {
  products: [
    { to: '/products', label: 'Products' },
    { to: '/labs', label: 'Labs' },
  ],
  company: [
    { to: '/about', label: 'About' },
    { to: '/team', label: 'Team' },
    { to: '/press', label: 'Press' },
    { to: '/events', label: 'Events' },
  ],
  blog: [
    { to: '/blog', label: 'Overview' },
    { to: '/blog/articles', label: 'Articles' },
    { to: '/blog/video', label: 'Video' },
  ],
};

export const MAIN_NAV = [
  { to: '/products', label: 'Products', section: 'products' },
  { to: '/about', label: 'About', section: 'company' },
  { to: '/blog', label: 'Blog', section: 'blog' },
  { to: '/research', label: 'Research' },
  { to: '/trust', label: 'Trust' },
  { to: '/faq', label: 'FAQ' },
];

export const MENU_GROUPS = [
  { label: 'Products', links: [...SECTIONS.products, { to: '/trust', label: 'Trust' }, { to: '/faq', label: 'FAQ' }] },
  { label: 'Company', links: SECTIONS.company },
  { label: 'Blog', links: [...SECTIONS.blog, { to: '/research', label: 'Research' }] },
];

const within = (pathname, to) => pathname === to || pathname.startsWith(`${to}/`);

export function isActive(item, pathname) {
  return item.section
    ? SECTIONS[item.section].some(p => within(pathname, p.to))
    : within(pathname, item.to);
}

export const GLOSS = {
  '/': 'Start from the top',
  '/products': 'What we make, and what it costs',
  '/labs': 'Side projects, labelled as such',
  '/about': 'Who we are and why we build',
  '/team': 'The people behind the company',
  '/press': 'Facts, logos and a ready brief',
  '/events': 'Where to meet us in person',
  '/blog': 'Field notes and video',
  '/blog/articles': 'Every article, newest first',
  '/blog/video': 'Vigilhold on screen',
  '/research': 'Papers on new ideas and engines',
  '/trust': 'Why every account is verified',
  '/faq': 'Plain answers to common questions',
  'https://vigilhold.com': 'The product’s own site',
  'https://vigilhold.com/register': '14 days, no card',
  'https://vigilhold.com/trust': 'Vigilhold’s security documentation',
};
